/* eslint class-methods-use-this: "off", react/prefer-stateless-function: "off" */

import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import _ from "underscore";

import Input from "@exovera/input";
import vars from "@exovera/narrative-tracker-variables";
import RoundSpinner from "genericComponents/RoundSpinner";

import { backToLogin, updateLoginEmail, recoverPassword } from "actions/login.js";

class ForgotPassword extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			focusEmail: false,
			emailError: false,
		};
		this.validateForm = this.validateForm.bind(this);
	}
	componentDidMount() {
		this.setState({ focusEmail: true }); // Doesn't work in the contructor
	}

	// just checking for empty fields
	validateForm(event) {
		event.preventDefault();
		const { props } = this;
		if (!props.validationInProgress && props.loginInputEmail) {
			this.setState({ emailError: false });
			props.dispatch(recoverPassword(props.loginInputEmail));
		} else if (!props.validationInProgress && !props.loginInputEmail) {
			this.setState({ emailError: true, focusEmail: true });
		}
	}
	render() {
		const { props, state } = this;
		// console.log("ForgotPassword", props.authState);
		const loginClass = classnames("login", { error: props.loginError });
		const emailErrorClass = classnames("login__error", { visible: state.emailError });
		const buttonBoxClass = classnames("login__submit-box", { spinner: props.validationInProgress });

		return (
			<div className={loginClass}>
				<div className="login__box">
					<p className="login__top-error">{props.loginErrorText}</p>

					<div className="login__return" onClick={() => props.dispatch(backToLogin())}>
						Return to login
					</div>

					<h1 className="login__header">Recover Password</h1>

					<div className="login__input-box">
						<label htmlFor="login-forgot-password-email" className="login__input-label">
							Enter your Email
						</label>
						<Input
							acceptBtnFunction={this.validateForm}
							focus={state.focusEmail} // can set focus by passing a prop
							label={false}
							id="login-forgot-password-email"
							// note: PropTypes.func, // appears below input. Expects a React component
							onChange={(value) => props.dispatch(updateLoginEmail(value))}
							placeholder=""
							// "dark", 'light', 'inline'. Themes show a box, none is inline. Add ' search' to any
							theme={props.darkUI ? "dark" : "blueGrey"}
							type="email"
							value={props.loginInputEmail}
						/>
						<p className={emailErrorClass}>Please enter your username or email address.</p>
					</div>

					<div className={buttonBoxClass}>
						<div className="login__spinner">
							<RoundSpinner scale={0.6} color={vars.cerulean_2} />
						</div>

						<button type="submit" className="login__submit" onClick={this.validateForm}>
							<span className="login__submit--text">Send Code</span>
						</button>
					</div>
				</div>
			</div>
		);
	}
}

ForgotPassword.propTypes = {
	dispatch: PropTypes.func.isRequired,
	validationInProgress: PropTypes.bool.isRequired,
	loginError: PropTypes.bool.isRequired,
	loginErrorText: PropTypes.string.isRequired,
	loginInputEmail: PropTypes.string.isRequired,
	loginInputPassword: PropTypes.string.isRequired,
};

export default ForgotPassword;
